import { API_BASE } from "helpers/api_config";
import { onayBekleyenSayisiniGetir } from "../../pages/Contacts/Moderation/moderationTypes";
import React, { useEffect, useRef, useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";


// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import axios from "axios";

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  const [getUserType, setUserType] = React.useState("Admin");
  const [getSeenPage, setSeenPage] = React.useState([]);

  // MetisMenu delegasyon kullanmaz; tik handler'larini her <a>'ya ayri ayri
  // baglar. Menu icerigi getUserType localStorage'dan okununca komple
  // degistigi icin (admin / admin-disi) mount'ta kurulan instance yeni
  // linkleri tanimiyordu — gruplar acilip kapanamiyordu. Bu yuzden menu
  // icerigi her degistiginde dispose edilip yeniden kuruluyor.
  useEffect(() => {
    // Once aktif sayfa isaretleniyor: MetisMenu init'i mm-active olan grubu
    // acik baslatiyor (ters sirada init tum gruplari kapali baslatip
    // activeMenu'nun actigi grubu tekrar kapatiyordu).
    activeMenu();
    const mm = new MetisMenu("#side-menu");
    return () => mm.dispose();
  }, [getUserType]);


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();

    let authUser = JSON.parse(localStorage.getItem("authUser"));
    if (authUser != null) {
      setUserType(authUser.Users_Type_ID)
    }

  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  useEffect(() => {
    getSearchAuth()

  }, []);

  // ---- ONAY BEKLEYEN SAYISI ----
  // Denetimde 52 icerigin (en eskisi 2023'ten) onay kuyrugunda unutuldugu
  // gorulunce eklendi: sayi menude gorunmezse kimse kuyruga bakmiyor.
  //
  // Hangi tablolarin sayilacagi Moderation sayfasiyla ayni yerden
  // (moderationTypes.js -> ONAY_SORGULARI) geliyor; boylece kuyruk turu
  // eklenince rozet ile sayfa birbirinden ayri dusmuyor.
  const [onayBekleyen, setOnayBekleyen] = useState(0);

  useEffect(() => {
    let iptal = false;
    onayBekleyenSayisiniGetir().then((toplam) => {
      if (!iptal) setOnayBekleyen(toplam);
    });
    return () => { iptal = true; };
  }, []);

  const getSearchAuth = async () => {
    // Oturum yoksa/bozuksa menü komple çökmemeli
    let authUser = null;
    try {
      authUser = JSON.parse(localStorage.getItem("authUser"));
    } catch (e) {
      authUser = null;
    }
    if (!authUser || authUser.Users_Type_ID == 1) return;

    try {
      const res = await axios.get(
        `${API_BASE}/getUsersAuthSearch/select/${authUser.Users_Type_ID}`
      );
      setSeenPage(Array.isArray(res.data) ? res.data : (res.data && res.data.value) || []);
    } catch (e) {
      // Yetki servisi erişilemezse ek menüler gizlenir, sayfa çalışmaya devam eder
      setSeenPage([]);
    }
  }
  return (
    getUserType == 1 ? <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {/* ---------------------------------------------------------
                MENU GRUPLARI

                GENEL            : her gun bakilan ekranlar (ozet + is kuyrugu)
                UYGULAMA ICERIGI : uygulamada kullaniciya gorunen icerikler
                REHBER & REKLAM  : gelir getiren bolumler
                YONETIM          : kullanici, rapor, ayar

                Onceki dizilimde "Anasayfa" hem grup basligi, hem panelin ana
                sayfasi, hem de uygulamanin ana sayfa icerikleri anlamina
                geliyordu; ucu birbirine karisiyordu. Berlin Amator Lig de
                icerik oldugu halde "Diger" altinda duruyordu.
            --------------------------------------------------------- */}

            <li className="menu-title">{props.t("Genel")}</li>

            <li>
              <Link to="/" >
                <i className="bx bx-tachometer"></i>
                <span>{props.t("Panel Özeti")}</span>
              </Link>
            </li>

            <li>
              <Link to="/moderation" >
                <i className="bx bx-shield-quarter"></i>
                <span>{props.t("Onay Bekleyenler")}</span>
                {onayBekleyen > 0 ? (
                  <span className="badge rounded-pill bg-danger float-end">
                    {onayBekleyen}
                  </span>
                ) : null}
              </Link>
            </li>

            <li>
              <Link to="/PopupList" >
                <i className="bx bx-bell"></i>
                <span>{props.t("Bildirimler")}</span>
              </Link>
            </li>

            {/* Kullanim kilavuzu public/kilavuz.html'de duran duz bir sayfa;
                react-router rotasi degil, bu yuzden <Link> degil <a>. */}
            <li>
              <a href="/kilavuz.html" target="_blank" rel="noopener noreferrer">
                <i className="bx bx-help-circle"></i>
                <span>{props.t("Kullanım Kılavuzu")}</span>
              </a>
            </li>

            <li className="menu-title">{props.t("Uygulama İçeriği")}</li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Uygulama Ana Sayfası")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/mainpagecategory">{props.t("Anasayfa Kategorisi")}</Link>
                </li>
                <li>
                  <Link to="/slider">{props.t("Slider")}</Link>
                </li>
                <li>
                  <Link to="/dinamikForm">{props.t("Anket (Ana Sayfa)")}</Link>
                </li>
                <li>
                  <Link to="/articleday">{props.t("Söz Sizde / Esnaf Aktüel")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-detail"></i>
                <span>{props.t("Aktüel")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/news">{props.t("Aktüel")}</Link>
                </li>
                <li>
                  <Link to="/newscategory">{props.t("Aktüel Kategorisi")}</Link>
                </li>
                <li>
                  <Link to="/newscomment">{props.t("Aktüel Yorumlar")}</Link>
                </li>
                <li>
                  <Link to="/poolaktuel">{props.t("Anket (Aktüel)")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-file"></i>
                <span>{props.t("İlan")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/jobadvertisement">{props.t("İlanlar")}</Link>
                </li>
                <li>
                  <Link to="/jobadvertisementcategory">{props.t("İlan Kategorisi")}</Link>
                </li>
                <li>
                  <Link to="/jobadvertisementsubcategory">{props.t("İlan Alt Kategorisi")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/forum" >
                <i className="bx bx-conversation"></i>
                <span>{props.t("Bir Bilen (Forum)")}</span>
              </Link>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-music"></i>
                <span>{props.t("Şarkı")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/song">{props.t("Şarkı")}</Link>
                </li>
                <li>
                  <Link to="/songcategory">{props.t("Şarkı Kategorisi")}</Link>
                </li>
              </ul>
            </li>

            {/* Spor sekmesinde gorunen kulup listesi — icerik oldugu icin
                "Diger" yerine bu grupta. */}
            <li>
              <Link to="/berlinamatorlig" >
                <i className="bx bx-football"></i>
                <span>{props.t("Berlin Amatör Lig")}</span>
              </Link>
            </li>

            <li className="menu-title">{props.t("Rehber & Reklam")}</li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-diamond"></i>
                <span>{props.t("Rehber")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/company">{props.t("Rehber")}</Link>
                </li>
                <li>
                  <Link to="/companycategory">{props.t("Rehber Kategorisi")}</Link>
                </li>
                <li>
                  <Link to="/companysubcategory">{props.t("Rehber Alt Kategorisi")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-star"></i>
                <span>{props.t("Reklam")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/Advert">{props.t("Liste Arası Reklamlar")}</Link>
                </li>
                <li>
                  <Link to="/advertesingcategory">{props.t("Reklam Kategorisi")}</Link>
                </li>
                <li>
                  <Link to="/advertesingform">{props.t("Reklam Alanları / Talepler")}</Link>
                </li>
                <li>
                  <Link to="/companyadvertprice">{props.t("Rehber Reklam Ücretleri")}</Link>
                </li>
              </ul>
            </li>

            <li className="menu-title">{props.t("Yönetim")}</li>

            <li>
              <Link to="/users" >
                <i className="bx bx-user"></i>
                <span>{props.t("Kullanıcılar")}</span>
              </Link>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-bar-chart-alt-2"></i>
                <span>{props.t("Raporlar")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/referral-report">{props.t("Referans Raporu")}</Link>
                </li>
                <li>
                  <Link to="/satin-alma-raporu">{props.t("Satın Alma Raporu")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/uygulamaayarlari" >
                <i className="bx bx-cog"></i>
                <span>{props.t("Uygulama Ayarları")}</span>
              </Link>
            </li>

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment> :
      <React.Fragment>
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">{props.t("Anasayfa")} </li>

              <li>
                <Link to="/calendar" >
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Anasayfa")}</span>
                </Link>
              </li>

              <li className="menu-title">{props.t("Yönetim")}</li>

              {getSeenPage.map((item, key) => (
                <li key={key}>
                  <Link to={item.Authority.Authority_Link} >
                    <i className="bx bx-calendar"></i>
                    <span>{item.Authority.Authority_Text}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
